<div>
  <input
    #transactionInput="cdkOverlayOrigin"
    cdkOverlayOrigin
    class="ag-text-field-input"
    type="text"
    [(ngModel)]="currentValue"
    (click)="openMenu()"
    [ngClass]="currentValue ? 'input-background-active' : ''" />
    @if (!currentValue) {
      <span class="sdps-dropdown__icon sch-chevron-small-down"></span>
    }
    @if (currentValue) {
      <span class="sdps-text-secondary delete-icon-padding" (click)="clearTransactionType($event)"
        ><img class="deleteIcon" [src]="deleteIcon"
      /></span>
    }
    <ng-template
      cdkConnectedOverlay
      (overlayOutsideClick)="toggleTransactionType(false)"
      (overlayKeydown)="toggleTransactionType(false)"
      [cdkConnectedOverlayOrigin]="transactionInput"
      [cdkConnectedOverlayOpen]="isOpen">
      <div class="container">
        <div class="radio-btns">
          <ul>
            @for (transactionType of transactionTypeOptions; track transactionType) {
              <div class="transactionType-item">
                <input
                  type="radio"
                  [id]="transactionType"
                  name="transactionType"
                  [(ngModel)]="selectedValue"
                  [value]="transactionType" />
                  <label [for]="transactionType" [innerText]="transactionType"></label>
                </div>
              }
            </ul>
          </div>
          <div class="filter-actions">
            <button type="button" class="btn btn-success" (click)="applyTransactionType()">Apply</button>
            <a href="#" (click)="clearTransactionType($event)"> Clear </a>
          </div>
        </div>
      </ng-template>
    </div>
